import { createSlice } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
    tab: 0,
    messageWorkOrders: null,
};

//Slice
const workOrdersMainRedux = createSlice({
    name: "workOrders/main",
    initialState: INIT_STATE,
    reducers: {
        setTab: (state, action) => {
            state.tab = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersMainRedux;

// Extract and export each action creator by name
export const { setTab } = actions;

// Export the reducer, either as a default or named export
export default reducer;
